export default "__VITE_ASSET__8969bcbb__"